import React from 'react';
import { AccordionHeader } from 'core/controls';

const OptionsAccordionHeader = ({ header, hideSingleCount, count }) => {
  const text = hideSingleCount && count <= 1 ? header : `${header} (${count})`;
  return <AccordionHeader analyticsKey={header}>{text}</AccordionHeader>;
};

export default OptionsAccordionHeader;
